(function ($) {

  $(document).ready(function () {
    $("a[href*=\\#]:not([href=\\#])").bind('touchstart click',
      function (e) {
        e = e || window.event;
        e.preventDefault();
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
          if (target.length) {
            $("html,body").animate({
              scrollTop: target.offset().top - 40
            }, 500);
            return true;
          }
        }
      }
    );
  });

}(jQuery));